/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useEffect as r}from"react";function t(t){return r((()=>()=>t()),[])}export{t as useUnmountEffect};
//# sourceMappingURL=use-unmount-effect.js.map
